import React, { useState, useEffect } from "react";
import {
  Grid, TableContainer, Table, TableCell, TableRow, List, ListItem, Button
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import FormHeader from "../../../../Components/FormHeader";
import { TabletView } from "react-device-detect";
import LocalPrintshopIcon from '@material-ui/icons/LocalPrintshop';
import CancelIcon from '@material-ui/icons/Cancel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SaveIcon from '@material-ui/icons/Save';

/** Local dependencies & Libraries */
import Services from '../../../../Services';


import { Imports } from '../../../../Imports';

import Snackbar from '../../../../Components/Snackbar';
import { formatSSN } from "../../../../Components/dummyConstant/DummyConstant";
import { useSelector } from "react-redux";
import { documentSubmit } from "../../../../helpers/api";

var moment = require('moment-timezone');


const {
  hr,
} = Services;


const {
  styles: {
    displayNoneStyles: useStyles
  }
} = Imports;


const TWICCardPaymentAgreement = () => {

  const classes = useStyles();
  const [isPosting, setPosting] = useState(false);
  const [hireDate, setHireDate] = useState(moment(new Date()).utc().format("MM-DD-YYYY"));
  const [signDate, setSignDate] = useState(moment(new Date()).utc().format("MM-DD-YYYY"));
  const [userData, setUserData] = useState({
    firstName: '',
    middleName: '',
    lastName: '',
    ssn: '',
  })
  const [adminData, setAdminData] = useState(null)
  document.addEventListener("storage", (event) => {   });
  const access = localStorage.getItem("access_jwt") || null
  const history = useHistory()


  useEffect(async () => {

    let userProfile = JSON.parse(localStorage.user_profile);
    let res = await hr.getAllApplicantsByIDApplicantLogin({ id: userProfile.id })
    let data = {
      firstName: res?.employee?.firstName || '',
      middleName: res?.employee?.middleName || '',
      lastName: res?.employee?.lastName || '',
      ssn: formatSSN(res?.employee?.ssn) || '',

      hireDate: res?.employee?.hireDate || '',
    }
    setUserData(data)
    setAdminData(userProfile)
     

    const { payDetails } = localStorage;

    if (payDetails) {
      const {
        pay: {
          PayType: { name: salaryType }
        },
        position: {
          EffectiveDate
        }
      } = JSON.parse(payDetails);

      setHireDate(
        moment(new Date(EffectiveDate)).utc()
      );
    }
  }, [])


  async function submit() {
     
    let data = {
      hireDate: hireDate,
      signature: document.getElementById('signature').value,
    }
    documentSubmit(setPosting, data, 9, [], access, history)
  }


  return (
    <Grid id="capture" container xs={12} className="LiqForms-Container">
      {/* <FormHeader/> */}
      <Grid className={isPosting ? classes.DisplayNone : 'FormsHeader'}>
        <List>
          <ListItem>
            <Grid className="FormMenuLogo"></Grid>
          </ListItem>
          <ListItem>
            <Button onClick={submit} >
              <SaveIcon />
            </Button>
          </ListItem>
          <ListItem>
            <Button onClick={() => window.print()}>
              <LocalPrintshopIcon />
            </Button>
          </ListItem>
          <ListItem>
            <Button onClick={() => window.close()}>
              <CancelIcon />
            </Button>
          </ListItem>
        </List>
      </Grid>
      <TableContainer className="MainTable capture">
        <Table className="SecondMainTable">
          <TableRow>
            <TableCell>
              <Table className="w100">
                <TableRow className="w100 mb10 mt10 row justify-center">
                  <TableCell>
                    {/* <div className="logoImageTGS"></div> */}
                    <div className="logoImageTGS"></div>
                  </TableCell>
                </TableRow>
                <TableRow className="w100">
                  <TableCell className="w100 textCenter font20 bold">
                    TWIC Card Payment Agreement
                  </TableCell>
                </TableRow>
              </Table>
              <Table className="mt10">
                {/* --**-- */}
                <TableRow className="w100 mt10">
                  <TableCell className="w100 row">
                    Hire Date:
                    {/* <DatePicker
                      onChange={(value) => { setHireDate(value) }}
                      value={hireDate}
                      id="offerDate"
                      className="datePickerReact pr0 pl0"
                      disabled
                    /> */}
                    {/* <DatePicker
                      disabled
                      className="datePickerReact"
                      defaultValue={moment()} format={'MM-DD-YYYY'}
                      id="offerDate"
                      onChange={(value) => { setHireDate(value) }}
                    /> */}
                    <input value={moment(hireDate).format('MM-DD-YYYY')} disabled />
                  </TableCell>
                </TableRow>
                <TableRow className="w100 mt10 row">
                  <TableCell className="w100 row">
                    Employee Name:
                    <input type="text" name="textfield" id="name" className="w h18 pl8 bn bb input-capitalization"
                      value={`${userData.firstName} ${userData.lastName}`}
                      disabled
                    />
                  </TableCell>
                </TableRow>
                <TableRow className="w100 mt10 row">
                  <TableCell className="w100 row">
                    Social Security #:
                    <input type="text" name="textfield" id="securityNumber" className="w h18 pl8 bn bb"
                      value={`${userData.ssn}`}
                      disabled
                    />
                  </TableCell>
                </TableRow>
                {/* -*- */}
                <TableRow className="w100 mt20 mb20">
                  <TableCell>
                    If for any reason I am terminated or resign from Trans-Global Solutions, Inc. within six (6) months of employment I agree to have the full cost of my Transportation Workers Identification Card (TWIC) deducted from my final paycheck.
                  </TableCell>
                </TableRow>
                {/* -*- */}
                <TableRow className="w100 mt20 mb20" style={{ border: '3px solid lightBlue' }}>
                  <TableCell className="w30">
                    <input type="text" name="textfield" id="signature" className="w100 pl8 bn bb mb10 signatureClass font-20"
                      autofocus />
                    Employee Signature
                  </TableCell>
                </TableRow>
                {/* -*- */}
                <TableRow className="w100 mt20 mb20">
                  <TableCell className="w30">
                    <p id="representative" className="w100 h18 pl8 bn bb mb10 signatureClassOther font-20"
                    > {`${adminData?.AEmployee?.firstName} ${adminData?.AEmployee?.lastName}`} </p>
                    Company Representative
                  </TableCell>
                </TableRow>
                {/* -*- */}
                <TableRow className="w100 mt20 mb20">
                  <TableCell className="w30">
                    <input type="text" name="textfield"
                      id="offerDate" className="w100 h18 pl8 bn bb mb10  font-20"
                      value={signDate}
                      onChange={($e) => { setSignDate($e?.target?.value) }}
                      disabled />
                    {/* <DatePicker
                      onChange={(value) => { setSignDate(value) }}
                      value={signDate}
                      id="offerDate"
                      className="datePickerReact mb10"
                    /> */}
                    Date Signed
                  </TableCell>
                </TableRow>
                {/* -*- */}
              </Table>
              {/* --**-- */}


            </TableCell>
          </TableRow>
          <TableRow className="w100 mt20 FooterRow">
            <TableCell className="w100 textCenter">
              Trans-Global Solutions, Inc.<br />
              1735 W. Cardinal Dr., Beaumont, Texas 77705<br />
              Phone (409) 720-5413 – Fax (409) 729-7041
            </TableCell>
          </TableRow>
        </Table>
      </TableContainer>
      <Snackbar></Snackbar>
    </Grid >
  );
}
export default TWICCardPaymentAgreement;